import { ref } from 'vue';

const getDashlets = () => {
    const dashlets_error = ref(null);
    const dashlets = ref([]);

    const loadDashlets = async () => {
  
      try {
        let data = await fetch("/api/dashlets");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        dashlets.value = await data.json();

        //console.log('getUserDashlets.js: ', userDashlets.value);
      } catch (err) {
        dashlets_error.value = err.message;
      }
    };

    return { dashlets, dashlets_error, loadDashlets};
}

export default getDashlets;  